import { useEffect } from "react";

export function App() {
  useEffect(() => {
    const userAgent = navigator.userAgent;

      // iOS
      if (/iPad|iPhone|iPod|Mac OS/.test(userAgent)) {
        window.location.href = "https://apps.apple.com/app/id6745512834";
        return;
      }

      // Android
        window.location.href = "https://play.google.com/store/apps/details?id=com.hug.go.hug_and_go";
  }, []);

  return (
    <div className="max-w-7xl mx-auto p-8 text-center relative z-10">
      
    </div>
  );
}

export default App;
